exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-1b2edf54]{background-color:#fbfbfb}.setting-body[data-v-1b2edf54]{background-color:#fdfdfd}input[data-v-1b2edf54],textarea[data-v-1b2edf54]{border-style:solid}.token_password_toggle[data-v-1b2edf54]{position:absolute;margin-top:-30px;right:20px}", ""]);

// exports
